<template>
  <div>
    <div>

      <div class="card mb-5 mb-3">
        <div class="card-header">
          <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
              đơn hàng</span></h3>
        </div>
        <div class="card-body">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <label>Mã đơn hàng:</label>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-input placeholder="Nhập mã đơn hàng" v-model="search.orderId" />
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <label>Ngày tạo:</label>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-date-picker format="DD/MM/YYYY" v-model="search.createDate" type="daterange" range-separator="-"
                    start-placeholder="Từ ngày" end-placeholder="đến ngày" style="width: 100%" />
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <label>Trạng thái:</label>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-select placeholder="Chọn trạng thái" v-model="search.odooIsPublished">
                    <el-option label="Tất cả" value=""></el-option>
                    <el-option label="Published" value="1"></el-option>
                    <el-option label="Unpublished" value="0"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>

            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <label>Tình trạng:</label>
              <el-row :gutter="10">
                <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                  <el-select placeholder="Chọn trạng thái" v-model="search.odooState">
                    <el-option label="Chờ xác nhận" value="sent"></el-option>
                    <el-option label="Xác nhận" value="sale"></el-option>
                    <el-option label="Đã hủy" value="cancel"></el-option>
                  </el-select>
                </el-col>
                <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                  <el-button plain type="primary" title="Tìm kiếm" @click="handleSearch"><i
                      class="fa fa-search"></i></el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>

      </div>

      <div class="card data-table mb-5 mb-xl-10">
        <div class="card-header py-3">
          <div style="padding: 5px 10px" class="form-row d-flex flex-row justify-content-between w-100">
            <div></div>
            <div class="d-flex">
              <el-button plain type="warning" style="margin-right:30px" @click="handleDataSync"
                v-loading.fullscreen.lock="isLoading" title="Đồng bộ"><i class="el-icon-refresh"></i></el-button>
              <el-radio-group v-model="viewType" class="viewType">
                <el-radio-button label="GRID" value="GRID" title="Lưới"><i class="fa fa-th"></i></el-radio-button>
                <el-radio-button label="TABLE" value="TABLE" title="Danh sách"><i
                    class="fa fa-bars"></i></el-radio-button>
              </el-radio-group>
            </div>

          </div>
        </div>
        <div class="card-body">
          <div class="col-md-12 tbl">
            <el-row :gutter="10" v-if="viewType == 'GRID'">
              <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="6" v-for="item in tableData.content"
                :key="item.nMaDonHangShop" style="margin-bottom:10px">
                <div class="product-card" @click="showOrder(item)">
                  <el-row :gutter="10">
                    <el-col :span="18">
                      <span class="product-name">{{ item.odooPartnerName }}</span>
                    </el-col>
                    <el-col :span="6" style="text-align:right" class="pr-2">
                      <span class="product-name">{{ convertToMoney(item.odooAmountTotal) }}</span>
                    </el-col>
                  </el-row>

                  <el-row :gutter="10">
                    <el-col :span="14">
                      <span class="product-text">[{{ item.odooName }}]</span>
                    </el-col>
                    <el-col :span="10" style="text-align:right" class="pr-2">
                    </el-col>
                  </el-row>

                  <el-row :gutter="10">
                    <el-col :span="14">
                      <span class="product-text"><i class="el-icon-timer"></i>
                        {{ momentTime2(item.odooDateOrder) }}</span>
                    </el-col>
                    <el-col :span="10" style="text-align:right" class="pr-2">
                      <el-tag type="success" v-if="item.cState == 'sale'">Hoàn thành</el-tag>
                      <el-tag type="danger" v-if="item.cState == 'cancel'">Đã hủy</el-tag>
                      <el-tag type="warning" v-if="item.cState == 'sent'">Chưa hoàn thành</el-tag>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>

            <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%"
              height="100%" fit stripe highlight-current-row v-if="viewType == 'TABLE'">
              <el-table-column prop="odooName" label="Mã đơn hàng" width="130" align="center">
                <template #default="scope">
                  <el-button type="text" @click="showOrder(scope.row)">{{ scope.row.odooName }}</el-button>
                </template>
              </el-table-column>

              <el-table-column prop="odooDateOrder" label="Ngày tạo" width="150" align="center">
                <template #default="scope">
                  <span v-if="scope.row.odooDateOrder">{{ momentTime(scope.row.odooDateOrder)
                    }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="odooPartnerName" label="Khách hàng">
              </el-table-column>
              <el-table-column label="Tổng tiền" width="150" align="right">
                <template #default="scope">
                  {{ convertToMoney(scope.row.odooAmountTotal) }}
                </template>
              </el-table-column>

              <el-table-column label="Trạng thái" width="140" align="center">
                <template #default="scope">
                  <el-tag type="success" v-if="scope.row.odooState == 'sale'">Xác nhận</el-tag>
                  <el-tag type="danger" v-if="scope.row.odooState == 'cancel'">Đã hủy</el-tag>
                  <el-tag type="warning" v-if="scope.row.odooState == 'sent'">Chờ xác nhận</el-tag>
                </template>
              </el-table-column>
              <el-table-column width="160" align="center">
                <template #default="scope">
                  <el-button type="primary" @click="showOrder(scope.row)"
                    v-if="scope.row.odooState == 'sent' || scope.row.odooState == 'draft'">
                    <span class="btn-inner--icon"><i class="fas fa-check"></i></span>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="col-12 py-2 pagination" style="justify-content: end">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog v-model="orderDialog" class="modalTemp" dataBackDrop="static" :show-close="false">
      <template #header="{ close, titleId, titleClass }">
        <div class="d-flex justify-content-between px-4 pt-4">
          <h2 slot="header" class="modal-title">
            Xác nhận đơn hàng
          </h2>
          <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
            @click="orderDialog = false">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
      </template>

      <el-row :gutter="10">
        <el-col :span="8">
          <fieldset style="border: 1px solid #ccc; border-radius: 5px" class="p-2">
            <legend style="font-size: 14px; width: 136px;" class="pl-2">
              Thông tin đơn hàng
            </legend>

            <el-form label-width="100px" class="demo-ruleForm flex-column">
              <el-form-item label="Mã đơn hàng:">
                <label class="font-weight-bold">{{ selectedItem.odooName }}</label>
              </el-form-item>
              <el-form-item label="Tổng tiền:">
                <label class="font-weight-bold" style="color:green">{{ convertToMoney(selectedItem.odooAmountTotal)
                  }}</label>
              </el-form-item>
              <el-form-item label="Ngày đặt:">
                <label class="font-weight-bold">{{ momentTime2(selectedItem.odooDateOrder)
                  }}</label>
              </el-form-item>
              <el-form-item label="Trạng thái:">
                <el-tag type="success" v-if="selectedItem.odooState == 'sale'">Xác nhận</el-tag>
                <el-tag type="danger" v-if="selectedItem.odooState == 'cancel'">Đã hủy</el-tag>
                <el-tag type="warning" v-if="selectedItem.odooState == 'sent'">Chờ xác nhận</el-tag>
              </el-form-item>
            </el-form>
          </fieldset>
        </el-col>
        <el-col :span="16">
          <fieldset style="border: 1px solid #ccc; border-radius: 5px" class="p-2">
            <legend style="font-size: 14px; width: 150px;" class="pl-2">
              Thông tin khách hàng
            </legend>

            <el-form label-width="150px" class="demo-ruleForm">
              <div class="row">
                <div class="col-sm productDetail">
                  <el-form-item label="Họ tên khách hàng:">
                    <label class="font-weight-bold" >{{ selectedItem.odooPartnerName }}</label>
                  </el-form-item>
                  <el-form-item label="Số điện thoại:">
                    <label class="font-weight-bold" >{{ selectedItem.odooPhone }}</label>
                  </el-form-item>
                  <el-form-item label="Email:">
                    <label class="font-weight-bold" >{{ selectedItem.odooEmail }}</label>
                  </el-form-item>
                  <el-form-item label="Địa chỉ giao hàng:">
                    <label class="font-weight-bold" >{{ selectedItem.odooPartnerShippingAddress }}</label>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </fieldset>
        </el-col>
      </el-row>

      <fieldset style="border: 1px solid #ccc; border-radius: 5px" class="p-2 mt-2">
        <legend style="font-size: 14px; width: 140px;" class="pl-2">
          Danh sách sản phẩm
        </legend>

        <div class="tbl-1">
          <el-table :data="selectedItem.orderDetailList" header-row-class-name="thead-light" :border="true" fit stripe
            highlight-current-row>
            <el-table-column prop="odooProductTemplateName" label="Sản phẩm" min-width="150">
              <template #default="scope">
                <el-button type="text" @click="showProduct(scope.row)">{{ scope.row.odooProductTemplateName
                  }}</el-button>
              </template>
            </el-table-column>

            <el-table-column prop="odooProductUomQty" label="Số lượng" width="130" align="center"></el-table-column>

            <el-table-column prop="odooPriceUnit" label="Đơn giá" width="130" align="right">
              <template #default="scope">
                {{ convertToMoney(scope.row.odooPriceUnit) }}
              </template>
            </el-table-column>
            <el-table-column prop="odooDiscount" label="Giảm giá (%)" width="130" align="center"></el-table-column>

            <el-table-column prop="odooPriceTotal" label="Thành tiền" width="130" align="right">
              <template #default="scope">
                {{ convertToMoney(scope.row.odooPriceTotal) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </fieldset>


      <template #footer>
        <el-button v-if="orderState == 'OPEN'" type="primary" @click="handleConfirmOrder"
          v-loading.fullscreen.lock="isLoading">
          Xác nhận đã nhận tiền
        </el-button>

        <el-button v-if="orderState == 'OPEN'" type="danger" @click="handleCancelOrder"
          v-loading.fullscreen.lock="isLoading">
          Hủy đơn
        </el-button>

        <el-button outline type="secondary" @click="orderDialog = false">Thoát</el-button>

      </template>
    </el-dialog>

    <product-detail :show="detailDialog" @hideDialog="hideDialog" :data="productId"></product-detail>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import moment from "moment";
import { convertToMoney } from "@/utils/stringUtils";
import ProductDetail from "@/views/ShopOdoo/Product/ProductDetail.vue"
import _ from 'lodash';
import { useStore } from "vuex";
import { Order } from "@/store/enums/StoreEnums";

export default {
  components: {
    ProductDetail
  },
  data() {
    return {
      store: useStore(),
      size: "",
      viewType: "TABLE",
      isLoading: false,
      isSearchLoading: false,
      tableData: [],
      search: {
        orderId: "",
        createDate: "",
        odooState: ""
      },
      pageRequest: { pageNum: 1, pageSize: 30 },
      detailDialog: false,
      selectedItem: {},
      fit: "cover",
      productId: null,
      orderDialog: false,
      orderState: "CLOSE" //OPEN, CLOSE
    };
  },
  methods: {

    handleConfirmOrder() {
      try {
        this.$confirm("Bạn có muốn xác nhận đơn hàng này không?", "Xác nhận",
          { confirmButtonText: "Xác nhận", cancelButtonText: "Hủy", type: "warning", }).then(() => {
            this.isLoading = true
            this.store.dispatch(Order.confirmOrder, this.selectedItem.odooId).then((res) => {
              this.isLoading = false
              if (res.code == 200) {
                ElMessage({ message: "Xác nhận đơn hàng thành công!", type: "success", });
                this.orderDialog = false
                this.handleSearch()
              }
              else
                ElMessage({ message: "Xác nhận đơn hàng thất bại! " + res.msg, type: "error", });
            });
          })
          .catch(() => { });
      }
      catch (ex) {
        this.isLoading = false
        console.log(ex);
      }
    },

    handleCancelOrder() {
      try {
        this.$confirm("Bạn có muốn hủy đơn hàng này không?", "Xác nhận",
          { confirmButtonText: "Xác nhận", cancelButtonText: "Hủy", type: "warning", }).then(() => {
            this.isLoading = true
            this.store.dispatch(Order.cancelOrder, this.selectedItem).then((res) => {
              this.isLoading = false
              if (res.code == 200) {
                ElMessage({ message: "Hủy đơn hàng thành công!", type: "success", });
                this.orderDialog = false
                this.handleSearch()
              }
              else
                ElMessage({ message: "Hủy đơn hàng thất bại! " + res.msg, type: "error", });
            });
          })
          .catch(() => { });
      }
      catch (ex) {
        this.isLoading = false
        console.log(ex);
      }
    },

    // handleDeleteOrderLine(data) {
    //     try {
    //       this.$confirm("Bạn có muốn hủy sản phẩm này không?", "Xác nhận",
    //       { confirmButtonText: "Xác nhận", cancelButtonText: "Hủy", type: "warning", }).then(() => {
    //           this.isLoading = true
    //           this.$api.order.deleteOrderLine(data).then((res) => {
    //             this.isLoading = false
    //             if (res.code == 200) {
    //               ElMessage({ message: "Hủy sản phẩm thành công!", type: "success",});
    //               this.selectedItem.orderDetailList = this.selectedItem.orderDetailList.filter(it => it.odooId != data.odooId)
    //               this.selectedItem.nTongTien = Number(this.selectedItem.nTongTien) - Number(data.odooPriceTotal)
    //               this.handleSearch()
    //             }
    //             else
    //               ElMessage({ message: "Hủy sản phẩm thất bại! " + res.msg, type: "error",});
    //           });
    //       })
    //       .catch(() => { });
    //     }
    //     catch(ex) {
    //       this.isLoading = false
    //       console.log(ex);
    //     }
    // },

    convertToMoney(num) {
      return convertToMoney(num) + "đ";
    },

    showOrder(row) {
      if (row.odooState == "draft" || row.odooState == "sent")
        this.orderState = "OPEN"
      else
        this.orderState = "CLOSE"
      this.selectedItem = Object.assign({}, row)
      console.log(this.selectedItem)
      this.orderDialog = true
    },

    showProduct(row) {
      this.productId = row.odooProductTemplateId
      this.detailDialog = true
    },

    hideDialog() {
      this.detailDialog = false
    },

    handleSearch() {
      this.findOrder();
    },

    findOrder(pageNum, pageSize) {
      this.isSearchLoading = true
      if (typeof pageNum == "number") this.pageRequest.pageNum = pageNum;
      else this.pageRequest.pageNum = 1;

      if (typeof pageSize == "number") this.pageRequest.pageSize = pageSize;
      else this.pageRequest.pageSize = 30;

      let fromDate = ""
      let toDate = ""
      if (this.search.createDate && this.search.createDate.length === 2) {
        fromDate = moment(this.search.createDate[0]).format("DD/MM/YYYY")
        toDate = moment(this.search.createDate[1]).format("DD/MM/YYYY")
      }


      this.pageRequest.columnFilters = {
        orderId: { value: this.search.orderId },
        odooState: { value: this.search.odooState },
        fromDate: { value: fromDate },
        toDate: { value: toDate },
      };

      this.store.dispatch(Order.findPageOrder, this.pageRequest).then((res) => {
        this.isSearchLoading = false
        if (res.code === 200 && res.data)
          this.tableData = res.data;
        else
          this.tableData = []
      });
    },

    handleDataSync() {
      try {
        this.isLoading = true
        this.store.dispatch(Order.dataSyncOrder).then((res) => {
          this.isLoading = false
          if (res.code == 200) {
            ElMessage({ message: res.msg, type: "success", });
            this.findOrder();
          } else {
            ElMessage({ message: `Đồng bộ thất bại, ` + res.msg, type: "error" });
          }
        });
      }
      catch (ex) {
        console.log(ex);
        this.isLoading = false
      }
    },

    handleSizeChange(val) {
      this.findOrder(this.pageRequest.pageNum, val);
    },
    handleCurrentChange(val) {
      this.findOrder(val, this.pageRequest.pageSize);
    },

    debounceSearchOrderId: _.debounce(function (string) {
      this.handleSearch()
    }, 500),
    momentTime(val) {
      return val ? moment(val).format("HH:mm - DD/MM/YYYY") : ""
    },
    momentTime2(val) {
      return val ? moment(val).format("DD/MM/YYYY HH:mm:ss") : ""
    }
  },
  mounted() {
    this.findOrder()
  },
  watch: {
    'search.orderId': function (newV) {
      this.debounceSearchOrderId(newV)
    },
  }
};
</script>

<style lang="scss" scoped>
.tbl-1 {
  height: calc(100vh - 500px);
}

.box-card {
  margin: 10px;
}

.product-card {
  padding: 5px;
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  align-items: center;
  cursor: pointer;
}

.product-name {
  font-size: 13px;
  font-weight: 500;
  margin-left: 5px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.product-text {
  font-size: 13px;
  margin-top: 5px;
  margin-left: 5px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.viewType label {
  margin-bottom: 0rem;
}
</style>

<style>
.modalTemp .modal-body {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.card-header {
  padding: 0px;
}

.font-details {
  font-size: 18px;
  font-weight: 500;
}

.el-date-editor .el-range-separator {
  width: 15%;
}

.daterange-order .el-input__inner {
  border: 1px solid #b1b4b8;
}

.product-card .el-tag {
  height: 16px !important;
  line-height: 15px !important;
  font-size: 11px;
}
</style>
